(function(){
  var FR=(document.documentElement.lang||'').toLowerCase().indexOf('fr')===0;
  var L=FR?{about:'À propos',more:'Détails'}:{about:'About this piece',more:'Details'};
  var I={
    about:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.8 4.7L18.5 9l-4.7 1.8L12 15.5l-1.8-4.7L5.5 9l4.7-1.3z"/><path d="M19 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/></svg>',
    features:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>',
    specs:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17L17 3l4 4L7 21z"/><path d="M7 13l2 2M10 10l2 2M13 7l2 2"/></svg>',
    material:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l9 5-9 5-9-5z"/><path d="M3 13l9 5 9-5"/></svg>',
    care:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3s6 6.5 6 11a6 6 0 01-12 0c0-4.5 6-11 6-11z"/></svg>',
    note:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>',
    box:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8l-9-5-9 5v8l9 5 9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg>',
    info:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16M4 12h16M4 18h10"/></svg>'
  };
  var CHEV='<svg class="wy-story__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  function kind(t){
    t=(t||'').toLowerCase();
    if(/about|à propos|a propos|description|overview|aperçu|présentation|presentation/.test(t)) return 'about';
    if(/feature|caractéristique|caracteristique|highlight|avantage|benefit/.test(t)) return 'features';
    if(/dimension|size|taille|measure|mesure|spec|weight|poids|technique/.test(t)) return 'specs';
    if(/material|matériau|materiau|matière|finish|fini|fabric|tissu/.test(t)) return 'material';
    if(/care|entretien|clean|nettoy/.test(t)) return 'care';
    if(/note|warning|attention|important|avertissement/.test(t)) return 'note';
    if(/include|box|contenu|inclus|package|assembl/.test(t)) return 'box';
    return 'info';
  }
  function isEmpty(n){return !n.querySelector('img,iframe,video,table')&&n.textContent.replace(/ /g,' ').trim()==='';}
  function isHead(n){
    if(/^H[1-6]$/.test(n.tagName)||n.classList.contains('wy-desc__h')) return true;
    if(n.tagName!=='P') return false;
    var kids=[].filter.call(n.childNodes,function(c){return !(c.nodeType===3&&c.textContent.trim()==='')&&c.nodeName!=='BR';});
    return kids.length===1&&(kids[0].nodeName==='STRONG'||kids[0].nodeName==='B')&&n.textContent.trim().length<70;
  }
  function lines(nodes){
    var out=[];
    nodes.forEach(function(n){
      if(n.tagName==='UL'||n.tagName==='OL'){[].forEach.call(n.querySelectorAll('li'),function(li){var x=li.textContent.trim();if(x)out.push(x);});return;}
      var tmp=document.createElement('div'); tmp.innerHTML=n.innerHTML.replace(/<br\s*\/?>/gi,'\n');
      tmp.textContent.split('\n').forEach(function(x){x=x.replace(/ /g,' ').trim();if(x)out.push(x);});
    });
    return out;
  }
  function el(tag,cls,txt){var e=document.createElement(tag);if(cls)e.className=cls;if(txt!=null)e.textContent=txt;return e;}
  function build(d){
    if(d.dataset.wyStoryDone) return; d.dataset.wyStoryDone='1';
    var nodes=[].slice.call(d.children);
    while(nodes.length===1&&(nodes[0].tagName==='DIV'||nodes[0].tagName==='SECTION')) nodes=[].slice.call(nodes[0].children);
    nodes=nodes.filter(function(n){return !isEmpty(n);});
    var secs=[],cur={title:null,nodes:[]};
    nodes.forEach(function(n){
      if(isHead(n)){if(cur.title||cur.nodes.length)secs.push(cur);cur={title:n.textContent.trim().replace(/[:：]\s*$/,''),nodes:[]};}
      else cur.nodes.push(n);
    });
    if(cur.title||cur.nodes.length) secs.push(cur);
    secs=secs.filter(function(x){return x.nodes.length;});
    if(!secs.length) return;
    var wrap=el('div','wy-story'), nav=el('div','wy-story__nav'), cards=[], lead=null;
    secs.forEach(function(sec,i){
      var k=sec.title?kind(sec.title):(i===0?'about':'info');
      if(i===0&&k==='about'){
        lead=el('div','wy-story__lead'); var kk=el('span','wy-story__k');
        kk.innerHTML=I.about; kk.appendChild(document.createTextNode(sec.title||L.about)); lead.appendChild(kk);
        sec.nodes.forEach(function(n){lead.appendChild(n);});
        wrap.appendChild(lead); return;
      }
      var card=el('details','wy-story__card'+(k==='note'?' wy-story__card--note':'')); card.open=true;
      var sm=el('summary'), ic=el('span','wy-story__ico'); ic.innerHTML=I[k];
      sm.appendChild(ic); sm.appendChild(document.createTextNode(sec.title||L.more)); sm.insertAdjacentHTML('beforeend',CHEV);
      card.appendChild(sm);
      var body=el('div','wy-story__body');
      if(k==='features'||k==='box'){
        var ul=el('ul','wy-story__feats'); lines(sec.nodes).forEach(function(x){ul.appendChild(el('li',null,x));}); body.appendChild(ul);
      } else if(k==='specs'){
        var dl=el('dl','wy-story__specs');
        lines(sec.nodes).forEach(function(x){
          var m=x.match(/^([^:：]{1,40})[:：]\s*(.+)$/);
          if(m){dl.appendChild(el('dt',null,m[1].trim()));dl.appendChild(el('dd',null,m[2].trim()));}
          else{dl.appendChild(el('dd','wy-full',x));}
        });
        body.appendChild(dl);
      } else { sec.nodes.forEach(function(n){body.appendChild(n);}); }
      card.appendChild(body); wrap.appendChild(card); cards.push(card);
      var b=el('button',null); b.type='button'; b.innerHTML=I[k]; b.appendChild(document.createTextNode(sec.title||L.more));
      b.addEventListener('click',function(){card.open=true;card.scrollIntoView({behavior:'smooth',block:'start'});});
      nav.appendChild(b);
    });
    if(cards.length>1) wrap.insertBefore(nav,lead?lead.nextSibling:wrap.firstChild);
    if(cards.length>3) cards.slice(3).forEach(function(c){c.open=false;});
    d.innerHTML=''; d.appendChild(wrap);
  }
  function run(){document.querySelectorAll('[data-wy-story]').forEach(build);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
})();